module.exports = __webpack_public_path__ + "main/assets/public/player/tick-icon.98804dd1ef0f3b9a.svg";